exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".report-filter-card[data-v-70ba5c25]{border:1px solid #e6ebf0;background:#fff}.report-table-host[data-v-70ba5c25]{width:100%}.cell-click-area[data-v-70ba5c25]{display:block;width:100%;min-height:24px;cursor:pointer}.pnr-link[data-v-70ba5c25]{color:#1976d2;text-decoration:none;font-weight:500}.pnr-link[data-v-70ba5c25]:hover{text-decoration:underline}.v-toolbar .v-btn[data-v-70ba5c25]{text-transform:none}", ""]);

// exports
